import { useParams } from "react-router-dom";
import { IndustryDetailTemplate } from "@/components/detail/IndustryDetailTemplate";
import { getIndustryDetail } from "@/data/industryDetails";
import NotFound from "@/pages/NotFound";

export default function IndustryDetail() {
  const { slug } = useParams();
  const data = getIndustryDetail(slug);
  if (!data) return <NotFound />;
  return <IndustryDetailTemplate data={data} />;
}
